var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartPalm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6753 15.4131C24.2211 16.1547 24.0628 17.1964 23.3211 17.7423L18.046 21.6298C17.071 22.3465 15.896 22.734 14.6835 22.734H8.00009H1.33335C0.59584 22.734 0 22.1381 0 21.4006V18.7339C0 17.9964 0.59584 17.4006 1.33335 17.4006H2.8667L4.73755 15.9006C5.6834 15.1422 6.85841 14.7339 8.07092 14.7339H11.3335H12.0001H14.6668C15.4043 14.7339 16.0002 15.3297 16.0002 16.0672C16.0002 16.8047 15.4043 17.4006 14.6668 17.4006H12.0001H11.3335C10.9668 17.4006 10.6668 17.7006 10.6668 18.0673C10.6668 18.4339 10.9668 18.7339 11.3335 18.7339H16.3585L21.3461 15.0589C22.0877 14.5131 23.1294 14.6714 23.6753 15.4131ZM8.06676 17.4006H8.02925C8.04175 17.4006 8.05425 17.4006 8.06676 17.4006Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3584 1.40039C7.59588 1.40039 6.1667 2.82957 6.1667 4.59209C6.1667 5.43793 6.5042 6.25044 7.10004 6.84628L11.4084 11.1547C11.7334 11.4797 12.2626 11.4797 12.5876 11.1547L16.9001 6.84628C17.496 6.25044 17.8335 5.43793 17.8335 4.59209C17.8335 2.82957 16.4043 1.40039 14.6418 1.40039C13.7959 1.40039 12.9834 1.73789 12.3876 2.33373L12.0001 2.72124L11.6126 2.33373C11.0168 1.73789 10.2042 1.40039 9.3584 1.40039Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPalm);
export default __webpack_public_path__ + "static/media/heart-palm.49f4e71030bd1182cdc6e011bfa898c3.svg";
export { ForwardRef as ReactComponent };